import React, { useState } from "react";
import "./Navbar.css";
import idCardPdf from "../assets/docs/id-card.pdf";

const Navbar = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = ["home", "about", "services", "contact", "certificate"];

  const handleNavClick = (item) => {
    if (item === "certificate") {
      window.open(idCardPdf, "_blank");
    } else {
      setActiveItem(item);
    }
  };

  return (
    <nav className="navbar">
      <div className="brand">Geetha M R</div>
      <ul className="nav-list">
        {navItems.map((item) => (
          <li key={item}>
            <a
              href={item === "certificate" ? "#" : `#${item}`}
              className={activeItem === item ? "active" : ""}
              onClick={(e) => {
                if (item === "certificate") e.preventDefault();
                handleNavClick(item);
              }}
            >
              {item.charAt(0).toUpperCase() + item.slice(1)}
            </a>
          </li>
        ))}
      </ul>
      <div className="nav-right">
        <button
          className="book-call"
          onClick={() => (window.location.href = "tel:9341015523")}
        >
          Book a Call
        </button>
      </div>
      <button className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        ☰
      </button>
      <div className={`dropdown ${isMenuOpen ? "open" : ""}`}>
        <ul className="nav-list-mobile">
          {navItems.map((item) => (
            <li key={item}>
              <a
                href={item === "certificate" ? "#" : `#${item}`}
                className={activeItem === item ? "active" : ""}
                onClick={(e) => {
                  if (item === "certificate") e.preventDefault();
                  handleNavClick(item);
                  setIsMenuOpen(false);
                }}
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </a>
            </li>
          ))}
        </ul>
        <button
          className="book-call-mobile"
          onClick={() => (window.location.href = "tel:9341015523")}
        >
          Book a Call
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
